import React, { Fragment, useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2"; // Para mostrar alertas de confirmación y éxito

function Equipo() {
  let { id } = useParams();
  const [list, setList] = useState([]);
  const [users, setUsers] = useState([]); // Lista de usuarios para el select
  const [editingItem, setEditingItem] = useState(null);
  const [selectedUserId, setSelectedUserId] = useState("");
  const [selectedRole, setSelectedRole] = useState(""); // "EVALUADOR" o "LIDER"

  // Fetch de datos para la lista de equipo
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: `https://suadesarrollo.azurewebsites.net/api/QEquipoUsuario?SolicitudId=${id}`,
    })
      .then((response) => {
        setList(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  // Fetch de datos para obtener usuarios
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://suadesarrollo.azurewebsites.net/Api/ObtenerUsuarioPorTipoUsuario?Tipo_Usuario=3",
    })
      .then((response) => {
        setUsers(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  // Función para manejar la edición
  const handleEditClick = (item) => {
    setEditingItem(item);
    setSelectedUserId(item.evaluadorId); // Guardar el id del evaluador seleccionado
    setSelectedRole(item.nombreRol); // Guardar el rol actual ("EVALUADOR" o "LIDER")
  };

  const handleSaveEdit = () => {
    // Crear un objeto que siempre incluya nombre y evaluadorId
    const dataToUpdate = {
      nombre: selectedRole || editingItem.nombreRol, // Usar el nuevo rol si existe, de lo contrario, usar el original
      evaluadorId: selectedUserId || editingItem.evaluadorId, // Usar el nuevo evaluadorId si existe, de lo contrario, usar el original
    };

    // Enviar siempre el objeto completo, no importa si hay cambios
    axios
      .put(
        `https://suadesarrollo.azurewebsites.net/api/ActualizaMiembro/${editingItem.id}`,
        dataToUpdate,
        {
          auth: {
            username: "BasicAuth@icontec.org",
            password: "yQLzqmR7eZSuAmQZUqhY",
          },
        },
      )
      .then(() => {
        Swal.fire(
          "Éxito",
          "Integrante actualizado correctamente",
          "success",
        ).then((result) => {
          if (result.isConfirmed) {
            setEditingItem(null);
            // Actualizar la lista después de editar
            setList((prevList) =>
              prevList.map((item) =>
                item.id === editingItem.id
                  ? { ...item, ...dataToUpdate }
                  : item,
              ),
            );
            // Recargar la página actual
            window.location.reload();
          }
        });
      })
      .catch((error) => {
        console.error(error);
        Swal.fire("Error", "No se pudo actualizar el integrante", "error");
      });
  };

  // Función para manejar la eliminación
  const handleDeleteClick = (id) => {
    Swal.fire({
      title: "¿Estás seguro?",
      text: "No podrás revertir esto",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(
            `https://suadesarrollo.azurewebsites.net/api/EliminaMiembro/${id}`,
            {
              auth: {
                username: "BasicAuth@icontec.org",
                password: "yQLzqmR7eZSuAmQZUqhY",
              },
            },
          )
          .then(() => {
            Swal.fire(
              "Eliminado",
              "Integrante eliminado correctamente",
              "success",
            );
            setList((prevList) => prevList.filter((item) => item.id !== id));
          })
          .catch((error) => {
            console.error(error);
            Swal.fire("Error", "No se pudo eliminar el integrante", "error");
          });
      }
    });
  };

  return (
    <Fragment>
      <div className="container">
        <div className="text-center">
          <div className="container-fluid">
            <div className="card shadow mb-4">
              <div className="card-header py-3">
                <h6 className="m-0 font-weight-bold text-primary">
                  Información del equipo Asignado
                </h6>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table
                    className="table table-bordered"
                    id="dataTable"
                    width="100%"
                    cellSpacing="0"
                  >
                    <thead>
                      <tr>
                        <th>Id</th>
                        <th>Nombre</th>
                        <th>Evaluador</th>
                        <th>Solicitud</th>
                        <th>Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {list.map((item) => (
                        <tr key={item.id}>
                          <td>{item.id}</td>
                          <td>
                            {editingItem && editingItem.id === item.id ? (
                              <select
                                className="btn btn-secondary btn-user btn-block"
                                value={selectedUserId}
                                onChange={(e) =>
                                  setSelectedUserId(e.target.value)
                                }
                              >
                                {users.map((user) => (
                                  <option key={user.id} value={user.id}>
                                    {user.nombre}
                                  </option>
                                ))}
                              </select>
                            ) : (
                              item.nombre
                            )}
                          </td>
                          <td>
                            {editingItem && editingItem.id === item.id ? (
                              <select
                                className="btn btn-secondary btn-user btn-block"
                                value={selectedRole}
                                onChange={(e) =>
                                  setSelectedRole(e.target.value)
                                }
                              >
                                <option value="EVALUADOR">EVALUADOR</option>
                                <option value="LIDER">LIDER</option>
                              </select>
                            ) : (
                              item.nombreRol
                            )}
                          </td>
                          <td>{item.solicitudId}</td>
                          <td>
                            {editingItem && editingItem.id === item.id ? (
                              <button
                                className="btn btn-primary"
                                onClick={handleSaveEdit}
                              >
                                Guardar
                              </button>
                            ) : (
                              <button
                                className="btn btn-primary"
                                onClick={() => handleEditClick(item)}
                              >
                                Editar
                              </button>
                            )}
                            <button
                              className="btn btn-danger ml-2"
                              onClick={() => handleDeleteClick(item.id)}
                            >
                              Eliminar
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default Equipo;
